import { Component } from '@angular/core';

@Component({
  selector: 'app-version-icon',
  templateUrl: './version-icon.component.html',
})
export class VersionIconComponent {

}


